import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TickerTape.css'; // CSS for ticker tape styling

const TickerTape = () => {
  const [stocks, setStocks] = useState([]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const apiUrl = 'https://falcon-algo.onrender.com/api/summary/markets';
        const priceSymbolList = [
          "RELIANCE","TCS","HDFCBANK","ICICIBANK","BHARTIARTL","SBIN","INFY","ITC",
          "HINDUNILVR","LT","BAJFINANCE","MARUTI","TATAMOTORS","HCLTECH","SUNPHARMA",
          "ONGC","NTPC","AXISBANK","ADANIENT","TITAN","KOTAKBANK","POWERGRID","ADANIPORTS",
          "ULTRACEMCO","ASIANPAINT","COALINDIA","M&M","BAJAJFINSV","BAJAJ-AUTO","WIPRO",
          "NESTLEIND","JSWSTEEL","TATASTEEL","GRASIM","SBILIFE","HINDALCO","LTIM","BPCL",
          "EICHERMOT","TECHM","HDFCLIFE","INDUSINDBK","CIPLA","BRITANNIA","DRREDDY",
          "DIVISLAB","TATACONSUM","SHRIRAMFIN","HEROMOTOCO","APOLLOHOSP"
        ];

        const bodyData = {
          exchangeAggReqMap: {
            NSE: {
              priceSymbolList: priceSymbolList,
              indexSymbolList: []
            },
            BSE: {
              priceSymbolList: [],
              indexSymbolList: []
            }
          }
        };

        const response = await axios.post(apiUrl, bodyData);
        if (response.data && response.data.exchangeAggRespMap && response.data.exchangeAggRespMap.NSE) {
          const nseStocks = response.data.exchangeAggRespMap.NSE;
          const updatedStocks = priceSymbolList.map(symbol => ({
            symbol: symbol,
            ltp: nseStocks.priceLivePointsMap[symbol]?.ltp || 0,
            dayChange: nseStocks.priceLivePointsMap[symbol]?.dayChange || 0,
            dayChangePerc: nseStocks.priceLivePointsMap[symbol]?.dayChangePerc || 0,
          }));
          setStocks(updatedStocks);
        } else {
          console.error('Unexpected API response:', response.data);
        }
      } catch (error) {
        console.error('Error fetching stock data:', error);
      }
    };

    fetchStockData(); // Initial fetch

    const interval = setInterval(fetchStockData, 1000); // Fetch data every 30 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, []);

  return (
    <div className="ticker-container">
      <div className="ticker-tape-wrapper">
        <div className="ticker-tape">
          {stocks.length > 0 && stocks.map((stock, index) => (
            <div className="ticker-item" key={index}>
              <img
                src={`https://s3tv-symbol.dhan.co/symbols/${stock.symbol}.svg`}
                alt={stock.symbol}
                className="ticker-logo"
              />
              <div className="ticker-details">
                <span className="ticker-symbol">{stock.symbol}</span>
                <span className="ticker-price">{stock.ltp}</span>
                <span className={`ticker-change ${stock.dayChange >= 0 ? 'green' : 'red'}`}>
                  {stock.dayChange.toFixed(2)}
                </span>
                ( <span className={`ticker-change ${stock.dayChangePerc >= 0 ? 'green' : 'red'}`}>
                  {stock.dayChangePerc.toFixed(2)}%
                </span>)
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TickerTape;
